import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../services/auth.service';

/**
 * Values of `message.response.status` in a 403 body, as documented in
 * docs/readonly-admin-role-api.md.
 */
const READ_ONLY_ADMIN = 'readonlyadmin';
const SUPER_ADMIN_ONLY = 'superadminonly';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  authService = inject(AuthService);
  router = inject(Router);
  messageService = inject(MessageService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const reason = error.error?.message?.response?.status;

        if (error.status === 403 && reason === READ_ONLY_ADMIN) {
          this.messageService.add({
            severity: 'error',
            summary: 'Nur Lesezugriff',
            detail: 'Diese Aktion ist für Ihr Konto nicht erlaubt.',
          });
        } else if (error.status === 403 && reason === SUPER_ADMIN_ONLY) {
          this.messageService.add({
            severity: 'error',
            summary: 'Keine Berechtigung',
            detail: 'Diese Aktion ist nur für Super-Administratoren erlaubt.',
          });
        } else if (error.status === 401 || error.status === 403) {
          this.router.navigate(['/auth/login']);
        }

        return throwError(() => error);
      }),
    );
  }
}
